import React from "react";
import { ConstructionOutlined } from "@mui/icons-material";
import { Box, Paper, Typography } from "@mui/material";

export default function DevelopmentPage({ title }) {
  return (
    <Box className="subcontract-page">
      <Paper className="subcontract-development" elevation={0}>
        <span><ConstructionOutlined /></span>
        <Typography variant="h5" fontWeight={750}>{title}</Typography>
        <Typography color="text.secondary">
          Chức năng này đang được phát triển và sẽ được bổ sung trong phiên bản tiếp theo.
        </Typography>
      </Paper>
    </Box>
  );
}
